import Cookies from "js-cookie";
import {COOKIE_NEWSLETTER_POPUP_EXPIRY_DAYS, COOKIE_NEWSLETTER_POPUP_SHOWN} from "./constants";

export function setNewsletterPopupCookie() {
  Cookies.set(COOKIE_NEWSLETTER_POPUP_SHOWN, 1, {
    expires: COOKIE_NEWSLETTER_POPUP_EXPIRY_DAYS,
    secure: true
  });
}
